import { Injectable, inject } from '@angular/core';
import { HttpService } from '@utils/http.service';
import { UtilsService } from '@utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private http = inject(HttpService);
  private utils = inject(UtilsService);

  public reportList = async (userId: number | null = null, date: string | null = null) =>
    await this.http.get(`/v1/report?${userId ? `userId=${userId}` : ''}${date ? `&date=${date}` : ''}`).then((response: any) => response.data);

  public myReportList = async (date: string | null = null) => await this.http.get(`/v1/my-report?${date ? `&date=${date}` : ''}`).then((response: any) => response.data);

  public reassign = async (body: any) => await this.http.post(`/v1/report/reassign`, body).then((response: any) => response.data);
}
